/**
 * skyblue-colorway.js
 * AJAX colorway switching for Skyblue Collective PDPs.
 *
 * On .skyblue-swatch--link click:
 *  1. Fetch full product page HTML
 *  2. Update accordion content from incoming, transplant old accordion
 *     group DOM nodes (open state intact) into the incoming tree
 *  3. Preserve video cells with the same media ID
 *  4. Full section swap: current.replaceWith(incoming)
 */

(function () {
  'use strict';

  // ── Accordion helpers ────────────────────────────────────────────────────────

  function normalizeAccordions(root) {
    root.querySelectorAll('details[is="accordion-disclosure"]').forEach(function (d) {
      d.style.height   = '';
      d.style.overflow = '';
      d.setAttribute('aria-expanded', d.hasAttribute('open') ? 'true' : 'false');
      var c = d.querySelector(':scope > .accordion__content');
      if (c) { c.style.opacity = ''; c.style.transform = ''; }
    });
  }

  // ── Video preservation ───────────────────────────────────────────────────────

  function preserveVideos(current, incoming) {
    var oldVids = current.querySelectorAll('.product-gallery__media[data-media-type="video"]');
    var newVids = incoming.querySelectorAll('.product-gallery__media[data-media-type="video"]');
    newVids.forEach(function (newCell) {
      var id = newCell.getAttribute('data-media-id');
      oldVids.forEach(function (oldCell) {
        if (oldCell.getAttribute('data-media-id') === id) newCell.replaceWith(oldCell);
      });
    });
  }

  // ── Section swap ─────────────────────────────────────────────────────────────

  function swapSection(current, incomingDoc, href) {
    var sectionId = current.id;

    var incoming = incomingDoc.getElementById(sectionId)
      || incomingDoc.querySelector('[id^="shopify-section-main"]')
      || incomingDoc.querySelector('[id^="shopify-section"]');

    if (!incoming) return false;

    // 1. Update accordion content from incoming
    var curAccordions = current.querySelectorAll('.accordion-group details[is="accordion-disclosure"]');
    var newAccordions = incoming.querySelectorAll('.accordion-group details[is="accordion-disclosure"]');
    for (var i = 0; i < Math.min(curAccordions.length, newAccordions.length); i++) {
      var curC = curAccordions[i].querySelector('.accordion__content');
      var newC = newAccordions[i].querySelector('.accordion__content');
      if (curC && newC) curC.innerHTML = newC.innerHTML;
    }

    // 2. Transplant old accordion groups (open state preserved) into incoming
    var oldGroups = current.querySelectorAll('.accordion-group');
    var newGroups = incoming.querySelectorAll('.accordion-group');
    for (var j = 0; j < oldGroups.length; j++) {
      if (!newGroups[j]) continue;
      normalizeAccordions(oldGroups[j]);
      newGroups[j].replaceWith(oldGroups[j]);
    }

    // 3. Preserve live video cells
    preserveVideos(current, incoming);

    // 4. Swap
    current.replaceWith(incoming);

    history.pushState({}, '', href);
    var newTitle = incomingDoc.querySelector('title');
    if (newTitle) document.title = newTitle.textContent;
    return true;
  }

  // ── HTML prefetch ─────────────────────────────────────────────────────────────
  // Fetch a colorway's page on hover/touch so the click swaps immediately.
  // HTML only, no image warming: the swapped section's own srcset handles that.

  var htmlCache = {};
  var CACHE_MAX = 10;

  function handleFrom(href) {
    var m = href && href.match(/\/products\/([^?#/]+)/);
    return m ? m[1] : null;
  }

  function getHtml(path) {
    if (!htmlCache[path]) {
      var keys = Object.keys(htmlCache);
      if (keys.length >= CACHE_MAX) delete htmlCache[keys[0]];
      htmlCache[path] = fetch(path, { credentials: 'include' })
        .then(function (r) {
          if (!r.ok) throw new Error('HTTP ' + r.status);
          return r.text();
        })
        .catch(function (err) {
          delete htmlCache[path];
          throw err;
        });
    }
    return htmlCache[path];
  }

  // /products/<handle>, plus ?variant= for the variant matching the current Pack choice
  function targetPath(swatch, handle) {
    var path = '/products/' + handle;
    var pack = selectedPack(document);
    var map = swatch.getAttribute('data-variant-map');
    if (!pack || !map) return path;
    var pairs = map.split('|');
    for (var i = 0; i < pairs.length; i++) {
      var at = pairs[i].lastIndexOf('=');
      if (pairs[i].slice(0, at) === pack) return path + '?variant=' + pairs[i].slice(at + 1);
    }
    return path;
  }

  function prefetch(e) {
    var swatch = e.target.closest && e.target.closest('.skyblue-swatch--link, [data-sbc-colorway-link]');
    if (!swatch) return;
    var handle = handleFrom(swatch.href);
    if (handle) getHtml(targetPath(swatch, handle)).catch(function () {});
  }

  document.addEventListener('pointerover', prefetch, { passive: true });
  document.addEventListener('touchstart', prefetch, { passive: true });
  document.addEventListener('focusin', prefetch);

  // ── Keep the Pack selection across colorway swaps ─────────────────────────────
  // On a 3-Pack, switching designs should land on that design's 3-Pack.

  function packFieldset(root) {
    var sets = root.querySelectorAll('variant-picker fieldset.variant-picker__option');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (legend && /^\s*pack\b/i.test(legend.textContent)) return sets[i];
    }
    return null;
  }

  function selectedPack(root) {
    var fs = packFieldset(root);
    var checked = fs && fs.querySelector('input:checked');
    var label = checked && fs.querySelector('label[for="' + checked.id + '"]');
    return label ? label.textContent.trim() : null;
  }

  // ── Click handler ─────────────────────────────────────────────────────────────

  document.addEventListener('click', function (e) {
    var swatch = e.target.closest('.skyblue-swatch--link, [data-sbc-colorway-link]');
    if (!swatch) return;

    e.preventDefault();

    var section = swatch.closest('[id^="shopify-section"]')
      || document.getElementById('shopify-section-main');

    if (!section) { window.location.href = swatch.href; return; }

    var href = swatch.href;
    var handle = handleFrom(href);
    if (!handle) { window.location.href = href; return; }

    var swatchRow = swatch.closest('.skyblue-color-swatches, .variant-picker__option');
    var path = targetPath(swatch, handle);
    if (swatchRow) swatchRow.style.opacity = '0.5';

    getHtml(path)
      .then(function (html) {
        var parser = new DOMParser();
        var incomingDoc = parser.parseFromString(html, 'text/html');
        var ok = swapSection(section, incomingDoc, path);
        if (!ok) throw new Error('swap failed');
      })
      .catch(function (err) {
        console.warn('[skyblue-colorway] falling back:', err.message);
        window.location.href = href;
      })
      .finally(function () {
        if (swatchRow) swatchRow.style.opacity = '';
      });
  }, true);

}());

